import type { AlienRuleSection } from './types';

export const blackoutSections: AlienRuleSection[] = [
  {
    "id": "ai:blackout:overview",
    "scenarioId": "blackout",
    "title": "Opis trybu",
    "summary": "Kooperacja przeciwko sabotażyście niszczącemu infrastrukturę kolonii.",
    "bullets": [
      "2–4 graczy",
      "Poziom trudności źródłowy: umiarkowany",
      "OP nie są śledzone"
    ]
  },
  {
    "id": "ai:blackout:components",
    "scenarioId": "blackout",
    "title": "Komponenty",
    "bullets": [
      "10 kafli odkryć",
      "10 znaczników Blackout",
      "6 kart Vandalism",
      "tor czasu i znacznik z rozdziału 2",
      "4 nagrody LSS z rozdziału 2"
    ]
  },
  {
    "id": "ai:blackout:setup",
    "scenarioId": "blackout",
    "title": "Przygotowanie",
    "steps": [
      "Usuń podstawowe kafle odkryć, znaczniki postępu, nagrody LSS, prywatne cele 13 i 15 oraz misję 4.",
      "Nie używaj OP ani znaczników postępu.",
      "Tor czasu połóż stroną 12.",
      "Znacznik czasu stroną Obcego ustaw: 2 graczy—6, 3—7, 4—8.",
      "Przygotuj talię 6 kart Vandalism i 10 znaczników Blackout."
    ]
  },
  {
    "id": "ai:blackout:victory",
    "scenarioId": "blackout",
    "title": "Zwycięstwo i porażka",
    "bullets": [
      "Wygrywacie po przesunięciu czasu z 1 na 0.",
      "Potrzebne cele: 2 graczy—6, 3—7, 4—8 ukończonych misji i/lub prywatnych celów.",
      "Każdy gracz może ukończyć wszystkie 3 prywatne cele.",
      "Przegrywacie przy 5 budynkach jednocześnie w blackout.",
      "Przegrywacie, jeśli trzeba przydzielić kolonistę do blackout, a żaden nie jest dostępny.",
      "Przegrywacie, jeżeli standardowy koniec gry nastąpi przed zwycięstwem."
    ]
  },
  {
    "id": "ai:blackout:vandalism",
    "scenarioId": "blackout",
    "title": "Rozpatrywanie karty Vandalism",
    "steps": [
      "Na końcu każdej tury odkryj kartę.",
      "Karta Obcego: potasuj wszystkie 6 kart; brak innego efektu.",
      "Karta budynku: najpierw dokończ blackout na już zdewastowanym budynku wskazanego typu.",
      "Jeżeli nie ma zdewastowanego, połóż token na normalnym budynku wskazanego typu.",
      "Jeżeli wszystkie takie budynki są blackout albo zaawansowane, zastosuj efekt do schronu.",
      "Przy wyborze właściciela schronu wybierz gracza z najmniejszą liczbą schronów w blackout; remis rozstrzyga wcześniejsza kolejność tury."
    ]
  },
  {
    "id": "ai:blackout:building-states",
    "scenarioId": "blackout",
    "title": "Cztery stany budynku",
    "bullets": [
      "Normalny: działa bez zmian.",
      "Zdewastowany: ma token Blackout, ale nadal działa.",
      "Blackout: ma token i leżącego kolonistę; nie liczy się do kompleksu, nie produkuje i nie może być ulepszony.",
      "Zaawansowany: odporny na wandalizm i blackout."
    ]
  },
  {
    "id": "ai:blackout:repair",
    "scenarioId": "blackout",
    "title": "Naprawianie",
    "bullets": [
      "Za każdym ukończeniem misji lub prywatnego celu zmniejsz czas o 1.",
      "Następnie usuń kolonistę z blackout do jego obszaru roboczego; w kopalni postaw go.",
      "Albo usuń pusty token Blackout.",
      "Zdewastowany budynek można też naprawić przez ulepszenie.",
      "Blackout z kolonistą można cofnąć wyłącznie przez ukończenie celu."
    ]
  }
];
